export const isOfficeReady = () =>
  typeof Office !== "undefined" && Office.context && Office.context.mailbox;

export const getDisplayName = () => {
  // if (!isOfficeReady()) return "";
  return Office.context.mailbox.userProfile.displayName || "No name available";
};

export const getUserEmail = () => {
  if (!isOfficeReady()) return "";
  return Office.context.mailbox.userProfile.emailAddress || "No email available";
};

export const getInitials = (displayName) =>
  displayName
    .split(" ")
    .filter(Boolean)
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const getItemId = () => {
  if (!isOfficeReady()) return "N\\A";
  return Office.context.mailbox.item.itemId;
};

export const convertToGraphId = (ewsId) => {
  if (!isOfficeReady()) return ewsId;
  return Office.context.mailbox.convertToRestId(ewsId, Office.MailboxEnums.RestVersion.v2_0);
};
